import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useStoreState, useStoreActions } from 'easy-peasy';

import UploadMediaComponent from "../widgets/uploadMedia/UploadMediaComponent.jsx";
import Loader from '../widgets/Loader.jsx';

import { URLS } from '../../services/axios';


const dropzoneOptions = {
    url: URLS.API_URL + "/_uploader/gallery/upload",
    headers: {
        'Cache-Control': null,
        'X-Requested-With': null
    },
    withCredentials: true,
    chunking: true,
    maxFilesize: 2000,
    chunkSize: 2000000,
    retryChunks: true,
    retryChunksLimit: 3,
    acceptedFiles: "video/*",
    maxFiles: 1,
    autoProcessQueue: false,
    addRemoveLinks: true,
    dictRemoveFile: "Retirer le fichier",
    dictDefaultMessage: "Charger une nouvelle expérience immersive",
    dictCancelUpload: "Annuler ",
    dictCancelUploadConfirmation:
        "Etes-vous sûr de vouloir annuler le chargement ? ",
};

const UploadVideoMediaFormComponent = forwardRef((props, ref) => {
    const { video, onSuccess } = props;


    const { apiData: { ACTIONS, BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);
    const { typeOfVideoMedia: allTypesOfVideoMedia } = BACKOFFICE_DEFAULT_VALUES;

	const {editVideoAddMedia} = useStoreActions(actions => actions.videos);
    const [uploadedMedia, setUploadedMedia] = useState(null);
    const [triggerUploadFile, setTriggerUploadFile] = useState(false);
    const [countFilesSelected, setCountFilesSelected] = useState(0);
    const [uploadFromUrl, setUploadFromUrl] = useState(false);



    const token = ACTIONS?.videos?.addOriginalMedia?.csrfToken;

    const videosMediaTypeListOptions = allTypesOfVideoMedia
        ?.map(videoMediaType =>
            <option
                key={'video_media_type' + videoMediaType.value}
                value={videoMediaType.value}
            >
                {videoMediaType.label}
            </option>);


    useEffect(() => {
            if (uploadedMedia) {
                submitForm();
            }
    }, [uploadedMedia])



    useEffect(() => {
        if (countFilesSelected === 0) {
            setTriggerUploadFile(false);
        }
    }, [countFilesSelected])



    const submitForm = () => {
        if (uploadedMedia || uploadFromUrl) {
            const formData = new FormData(document.getElementById('video-media-uploadData-form'));
            if (uploadedMedia) {
                formData.append('media[fileName]', uploadedMedia.fileName);
                formData.append('media[fileSize]', uploadedMedia.fileSize);
            }
            editVideoAddMedia({ formData: formData, uniqueId: video.uniqueId }).then(() => {
                onSuccess();
            });
        } else {
            setTriggerUploadFile(true);
        }
    };


    useImperativeHandle(ref, () => ({
        submitForm
    }));

	return (
		<div>
	  		<div>
				<Form id="video-media-uploadData-form" method="post" encType="multipart/form-data">
                    <Form.Label>Upload via un lien ?</Form.Label>

                    <Form.Select name="media[uploadByURL]"
                        onChange={(e) => {
                            setUploadFromUrl(e.target.value === "yes");
                            if (e.target.value === "no") {
                                document.getElementsByName("media[fileUrl]")[0].value = "";
                            }
                        }}>
                        <option
                            key={'video_media_upload_type_no'}
                            value="no"

                        >
                            Non
                        </option>
                        <option
                            key={'video_media_upload_type_yes'}
                            value="yes"
                        >
                            Oui
                        </option>
                    </Form.Select>
                    <br />

                    {uploadFromUrl ?
                        <>
                            <InputGroup>
                                <InputGroup.Text>Lien :</InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="https://www.exemple.com/video.mp4"
                                    name="media[fileUrl]"
                                />
                            </InputGroup>
                            <br />
                        </>
                        :
                        <>
                            <UploadMediaComponent  {...dropzoneOptions}
                                onFileSelected={(fileQueueLength) => setCountFilesSelected(fileQueueLength)}
                                onFileUploaded={(file) => setUploadedMedia(file)}
                                triggerUploadFile={triggerUploadFile}
                            />
                            <br />
                        </>
                    }

                    <Form.Label>Types de fichiers video</Form.Label>
                    {videosMediaTypeListOptions ?
                        <Form.Select name="media[fileType]" >
                            {videosMediaTypeListOptions}
                        </Form.Select>
                        : <Loader />
                    }
                    <br />


                    <Form.Group >
                        <Form.Control
                            name="csrf_token"
                            defaultValue={token}
                            type="hidden"
                        />
                    </Form.Group>
                </Form>
			</div>
		</div>
	);
});

export default UploadVideoMediaFormComponent;
